
export default [
    //特价管理
     {
        path: '/pricenew',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/price/pricenew.vue'),
         meta: {
             title: '特价列表(外)',
             isTabsPage: true,
             keepAlive:true
         }
    },
     {
        path: '/pricenewCG',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/price/pricenewCG.vue'),
         meta: {
             title: '采购特价',
             isTabsPage: true,
             keepAlive:true
         }
        // 设置meta
    },
    {
        path: '/pricenewN',
        // 内销特价管理
        component: () => import( '@/views/loud/price/pricenewN.vue'),
        meta: {
            title: '特价列表(内)',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/pricenewFW',
        // 服务特价管理
        component: () => import( '@/views/loud/price/pricenewFW.vue'),
        meta: {
            title: '特价列表(服务)',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        // 上海特价管理
        path: '/pricenewSH',
        name: '/pricenewSH',
        component: () => import( '@/views/loud/price/pricenewSH.vue'),
        meta: {
            title: '特价列表(上海)',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/price/priceDetail',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/price/priceDetail.vue')
    },
    {
        path: '/price/priceToDetail',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/price/priceToDetail.vue')
    },
    {
        path: '/pricePass',
        // which is lazy-loaded when the route is visited.
        component: () => import( '@/views/loud/price/pricePass.vue')
    },
    {
        path: '/newprice',
        component: () => import( '@/views/loud/price/newprice.vue')
    },
    {
        path: '/newprice2',
        component: () => import( '@/views/loud/price/newprice2.vue')
    },
    {
        path: '/newCGprice',
        component: () => import( '@/views/loud/price/newCGprice.vue')
    },
    {
        path: '/resourcePool',
        component: () => import( '@/views/loud/resourcePool/resourcePool.vue'),
        meta: {
            title: '资源池',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/areaForecast',
        component: () => import( '@/views/loud/resourcePool/areaForecast.vue'),
        meta: {
            title: '区域预测趋势表',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/resourceAdvance',
        component: () => import( '@/views/loud/resourcePool/resourceAdvance.vue'),
        meta: {
            title: '资源池预借',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/shpAdvance',
        component: () => import( '@/views/loud/resourcePool/shpAdvance.vue')
    },
    {
        path: '/poolDetail',
        component: () => import( '@/views/loud/resourcePool/poolDetail.vue'),
        meta: {
            title: '资源池占用明细',
            isTabsPage: true,
            keepAlive:true
        }
    },
    {
        path: '/poolSummary',
        component: () => import( '@/views/loud/resourcePool/poolSummary.vue'),
        meta: {
            title: '资源池汇总',
            isTabsPage: true,
            keepAlive:true
        }
    },

]
